import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../../component/shared/shared.service';
import {PromotionCodeLogService} from '../services/promotion-code-log.service';
import {PromotionCodeLog} from '../model/promotion-code-log';
@Component({
  selector: 'app-promotion-code-log',
  templateUrl: './promotion-code-log.component.html',
  styleUrls: ['./promotion-code-log.component.css']
})
export class PromotionCodeLogComponent implements OnInit {

  promotionCodeLog: Array<PromotionCodeLog>;

  constructor(private _sharedService: SharedService, private _promotionCodeLogService: PromotionCodeLogService) { }

  ngOnInit() {
    this.getPromotionCodeLog();
  }

  getPromotionCodeLog(): void {
    this._promotionCodeLogService.getPromotionCodeLog().subscribe(data => {
       this.promotionCodeLog = data;
    }, error => {

    });
 }

 ngAfterViewChecked() {
    this._sharedService.emitChange(false);
  }
  ngOnDestroy() {
    this._sharedService.emitChange(true);
  }
}



// WEBPACK FOOTER //
// ./src/app/section/report/promotion-code-log/promotion-code-log.component.ts